import { IAftnMessage, INotam } from '@naviair-utm/node-shared-interfaces';
import moment from 'moment';
import React from 'react';
import { styles } from '../../Styles/styles';
import { newMessageTag, tag } from '../InfoPage/TableCol/helpers';
import { headerTagDateFormatter, IAftnMessageFC } from './AftnMessages';
import './styles.scss';

/** Text for the end of validity. An estimated end time (EST in field C) is suffixed with EST */
const notamEndText = (message: IAftnMessage<INotam>): string => {
	const end = message.validity?.end;
	if (!end) return 'PERM';
	return `${headerTagDateFormatter(new Date(end))}${message.parsedMessage.schedule?.estimated ? ' EST' : ''}`;
};

export const NotamHeader: React.FC<IAftnMessageFC<INotam>> = (props) => (
	<div className={'aftnRow aftnHeader notamHeader'} key={`notam_header_${props.index}`}>
		<div className={'aftnCol bold'}>{`${props.message.parsedMessage.rawFields?.a ?? ''}`}</div>
		<div className={'aftnCol bold'}>{`${props.message.parsedMessage.qualification?.location ?? ''}`}</div>
		<div className={'aftnCol bold'}>{`${props.message.parsedMessage.header?.id ?? ''}`}</div>

		<div className={'aftnCol'}>{newMessageTag(props.message.receivedDateTime)}</div>
		<div className={'aftnCol'}>
			{tag(
				props.message.validity?.start ? headerTagDateFormatter(new Date(props.message.validity.start)) : '',
				undefined,
				props.message.validity?.start && moment(new Date()).unix() < moment(new Date(props.message.validity.start)).unix() ? styles.COLOR_YELLOW : undefined
			)}
		</div>
		<div className={'aftnCol'}>
			{tag(
				notamEndText(props.message),
				props.message.validity?.end && moment(new Date()).unix() > moment(new Date(props.message.validity.end)).unix()
			)}
		</div>
	</div>
);

export const NotamHeaderMobile: React.FC<IAftnMessageFC<INotam>> = (props) => (
	<div className={'aftnRow mobile aftnHeader notamHeader'} key={`notam_header_mobile_${props.index}`}>
		<div className={'aftnCol mobile bold'}>
			<div>{`${props.message.parsedMessage.rawFields?.a ?? ''}`}</div>
			{newMessageTag(props.message.receivedDateTime)}
		</div>
		<div className={'aftnCol mobile bold'}>
			<div>{`${props.message.parsedMessage.qualification?.location ?? ''}`}</div>
			{tag(
				props.message.validity?.start ? headerTagDateFormatter(new Date(props.message.validity.start)) : '',
				undefined,
				props.message.validity?.start && moment(new Date()).unix() < moment(new Date(props.message.validity.start)).unix() ? styles.COLOR_YELLOW : undefined
			)}
		</div>
		<div className={'aftnCol mobile bold'}>
			<div>{`${props.message.parsedMessage.header?.id ?? ''}`}</div>
			{tag(
				notamEndText(props.message),
				props.message.validity?.end && moment(new Date()).unix() > moment(new Date(props.message.validity.end)).unix()
			)}
		</div>
	</div>
);

export const NotamContent: React.FC<IAftnMessageFC<INotam>> = (props) => {
	return (
		<React.Fragment key={`notam_${props.index}`}>
			{props.message.parsedMessage.rawFields &&
				Object.keys(props.message.parsedMessage.rawFields).map((field, index) => {
					if (!['HEADER', 'Q', 'A'].includes(field.toLocaleUpperCase())) {
						return (
							<div key={`${props.message.parsedMessage.header?.id}${field}${index}`} className={'aftnRow aftnContent noPadding'}>
								{/* eslint-disable-next-line react/forbid-dom-props */}
								<div className={'aftnCol bold'} style={{ width: 48, maxWidth: 48 }}>{`${field.toLocaleUpperCase()}) `}</div>
								<div className={'aftnCol italic'}>{props.message.parsedMessage.rawFields?.[field]}</div>
							</div>
						);
					}
				})}
		</React.Fragment>
	);
};
